import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const CTA = () => {
  return (
    <section className="bg-dark py-20 px-4 md:px-8 relative overflow-hidden">
      <div className="max-w-5xl mx-auto">
        {/* Background decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-red-500/10 rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-red-500/5 rounded-full blur-3xl -z-10"></div>
        
        <div className="relative z-10 bg-gradient-to-br from-red-600 via-red-500 to-red-600 rounded-3xl p-12 md:p-20 text-center overflow-hidden">
          {/* Inner glow */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
          
          <div className="relative z-20 space-y-6">
            <div className="space-y-3">
              <p className="text-red-100 text-sm font-semibold uppercase tracking-wider">Transform Your Game</p>
              <h2 className="text-5xl md:text-6xl font-bold text-white leading-tight">
                Join 10,000+ Players
              </h2>
              <p className="text-red-100 text-lg max-w-2xl mx-auto">
                Start organizing and joining matches across Bangladesh today. Find your perfect team in just a few clicks.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
              <Link to="/register" className="inline-flex items-center justify-center bg-white hover:bg-gray-100 text-red-600 font-bold py-4 px-8 rounded-lg transition-all duration-300 hover:shadow-lg shadow-black/30 gap-2">
                Get Started Now <FiArrowRight className="w-5 h-5" />
              </Link>
              <Link to="/discover" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white/10 font-bold py-4 px-8 rounded-lg transition-all duration-300 gap-2">
                Explore Matches <FiArrowRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
